import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject
} from '@apollo/client'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { JWT_COOKIE_NAME } from '../Constants'
import { GraphQLClientProps } from './types'

export const useGraphQLClient = ({
  clientUri
}: GraphQLClientProps): ApolloClient<NormalizedCacheObject> => {
  const [client, setClient] =
    useState<ApolloClient<NormalizedCacheObject>>(undefined)
  const [cookies] = useCookies([JWT_COOKIE_NAME])

  useEffect(() => {
    const hostListingsClient = new ApolloClient({
      uri: clientUri,
      headers: {
        'x-HeadBox-AccessToken': cookies[JWT_COOKIE_NAME]
      },
      cache: new InMemoryCache()
    })

    setClient(hostListingsClient)
  }, [cookies])

  return client
}
